import type { HTMLAttributes, ReactNode } from 'react';

export interface HeaderFiltersProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode;
  subtitle?: ReactNode;
  decorationImage?: string;
  backgroundImage?: string;
}
